var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 15V3","key":0}),React.createElement("path",{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4","key":1}),React.createElement("path",{"d":"m7 10 5 5 5-5","key":2})]);
}

Download.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-download-icon lucide-download"};

module.exports = Download;

Download.default = Download;
